export const API_BASE_PATH = '/api';

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `${API_BASE_PATH}/auth/login`,
    LOGOUT: `${API_BASE_PATH}/auth/logout`,
    ME: `${API_BASE_PATH}/auth/me`,
    CHANGE_PASSWORD: `${API_BASE_PATH}/auth/change-password`,
  },
  USERS: {
    LIST: `${API_BASE_PATH}/users`,
    BY_ID: (id: number) => `${API_BASE_PATH}/users/${id}`,
    PASSWORD: (id: number) => `${API_BASE_PATH}/users/${id}/password`,
  },
  GUESTS: {
    LIST: `${API_BASE_PATH}/guests`,
    BY_ID: (id: number) => `${API_BASE_PATH}/guests/${id}`,
    AUDIT: (id: number) => `${API_BASE_PATH}/guests/${id}/audit`,
    AVAILABLE_ROOMS: `${API_BASE_PATH}/guests/rooms/available`,
    DOCUMENTS: (bookingId: number) => `${API_BASE_PATH}/guests/${bookingId}/documents`,
    DOCUMENT_BY_ID: (bookingId: number, docId: number) => `${API_BASE_PATH}/guests/${bookingId}/documents/${docId}`,
  },
  NOTIFY: {
    WHATSAPP: (id: number) => `${API_BASE_PATH}/notify/${id}/whatsapp`,
    EMAIL: (id: number) => `${API_BASE_PATH}/notify/${id}/email`,
  },
  ERRORS: `${API_BASE_PATH}/errors`,
} as const;

export const UPLOAD_PATHS = {
  BOOKING_DOCUMENT: (bookingId: number, filename: string) => `/uploads/bookings/${bookingId}/${filename}`,
} as const;
